import { api } from '@api/api';
import {
  AddBuyersCertificateConsent,
  BuyersCertificateAddResponse,
  BuyersCertificateConsent,
  BuyersCertificateDetailsResponse,
  BuyersCertificateProductGroupsResponse,
  BuyersCertificateSearchResponse,
} from './types';
import { ProductFilterOptions } from './types/product-filters/ProductFilters';

export const buyersCertApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addBuyersCertificate: builder.mutation<BuyersCertificateAddResponse, FormData>({
      query: (params) => ({
        url: `/api/buyers-certificate/add`,
        method: 'POST',
        body: params,
      }),
    }),

    getBuyersCertificate: builder.query<BuyersCertificateSearchResponse, any>({
      query: (params) => ({
        method: 'POST',
        url: `/api/buyers-certificate/search`,
        body: params,
      }),
      providesTags: [{ type: 'BuyersCertificate', id: 'Message' }],
    }),

    getBuyersCertificateDetails: builder.query<BuyersCertificateDetailsResponse, string>({
      query: (params) => ({
        url: `/api/buyers-certificate/details?certificateId=${params}`,
      }),
    }),

    getBuyersCertificateBySerialNumber: builder.query<BuyersCertificateDetailsResponse, string>({
      query: (params) => ({
        url: `/api/buyers-certificate/detailsBySerialNumber?serialNumber=${params}`,
        method: 'GET',
      }),
    }),

    getBuyersCertificateExport: builder.query<any, number[]>({
      query: (params) => ({
        url: `/api/buyers-certificate/exportData`,
        method: 'POST',
        body: params,
        responseHandler: (response) => response.blob(),
      }),
    }),

    getBuyerCertificateConsent: builder.query<BuyersCertificateConsent, string>({
      query: (params) => ({
        url: `/api/buyers-certificate/consent/${params}`,
        method: 'GET',
      }),
    }),

    addBuyersCertificateConsent: builder.mutation<any, AddBuyersCertificateConsent>({
      query: (params) => ({
        url: `/api/buyers-certificate/consent`,
        method: 'POST',
        body: params,
      }),
    }),

    getBuyersCertificateProductFilters: builder.query<ProductFilterOptions, void>({
      query: () => ({
        url: `/api/buyers-certificate/productFilters`,
        method: 'GET',
      }),
    }),

    updateBuyersCertificate: builder.mutation<BuyersCertificateAddResponse, FormData>({
      query: (params) => ({
        url: `/api/buyers-certificate/update`,
        method: 'PUT',
        body: params,
      }),
    }),

    getBuyersCertificateProductGroups: builder.query<BuyersCertificateProductGroupsResponse, void>({
      query: () => ({
        url: `/api/buyers-certificate/productGroups`,
        method: 'GET',
      }),
    }),

    deleteBuyersCertificate: builder.mutation<any, number>({
      query: (params) => ({
        url: `/api/buyers-certificate/delete?buyersCertificateId=${params}`,
        method: 'DELETE',
      }),
    }),

  }),
});

export const {
  useLazyGetBuyersCertificateQuery,
  useGetBuyersCertificateDetailsQuery,
  useLazyGetBuyersCertificateBySerialNumberQuery,
  useAddBuyersCertificateMutation,
  useLazyGetBuyersCertificateExportQuery,
  useGetBuyerCertificateConsentQuery,
  useAddBuyersCertificateConsentMutation,
  useGetBuyersCertificateProductFiltersQuery,
  useUpdateBuyersCertificateMutation,
  useGetBuyersCertificateProductGroupsQuery,
  useDeleteBuyersCertificateMutation,
} = buyersCertApi;
